import React from 'react';
import PropTypes from 'prop-types';

const DLGPaymentMethodBoxComponent = ({ title, medias }) =>
  medias ? (
    <div className='dln-cart_paymentBox'>
      <span>{title}</span>
      <ul>
        {medias.map(image => (
          <li key={image.code}>
            <img
              src={`${window.location.origin}${image.url}`}
              alt={image.altText}
            />
          </li>
        ))}
      </ul>
    </div>
  ) : (
    <div />
  );

DLGPaymentMethodBoxComponent.propTypes = {
  title: PropTypes.string,
  medias: PropTypes.arrayOf(PropTypes.shape()),
};

DLGPaymentMethodBoxComponent.defaultProps = {
  title: null,
  medias: {},
};

export default DLGPaymentMethodBoxComponent;
